<template>
  <div id="page">
    <van-image :src="banr" :style="{display:'block'}" />
    <sx-grid></sx-grid>
    <div class="bg-white pdl-a">香港七星堂 (C) 版权所有</div>
  </div>
</template>

<script>
//mapMutations
import { mapState } from "vuex";
import sxGrid from "../components/sx-grid";
export default {
  name: "index",
  components: { sxGrid },
  data() {
    return {
      banr: require("../assets/img/top-bar.jpg")
    };
  },
  computed: {
    ...mapState(["sxArr"])
  },
  mounted() {
    console.log("process.env.VUE_APP_TEST", process.env.VUE_APP_SXURL);
  },
  methods: {}
};
</script>

<style scoped>
</style>